import { createAuthClient } from "better-auth/react";

/**
 * 管理画面APIの基点URL
 */
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

if (!API_BASE_URL) {
  throw new Error("VITE_API_BASE_URL is required");
}

/**
 * Googleサインイン専用の認証クライアント
 */
export const authClient = createAuthClient({
  baseURL: API_BASE_URL,
  basePath: "/v1/admin/auth",
  fetchOptions: {
    credentials: "include",
  },
});
